import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount_life_insurance__",
        fields: [
            {
                // label: '',
                name: 'requested_amount',
                placeholder: '1000',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_100k_less__", "value": "100000"},
                    {"text": "__opt_100k_250k__", "value": "250000"},
                    {"text": "__opt_250k_500k__", "value": "500000"},
                    {"text": "__opt_500k_1m__", "value": "1000000"},
                    {"text": "__opt_1m_more__", "value": "1500000"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__what_province__",
        fields: [
            {
                name: 'state',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: true,
            },
        ],
        // hideButtonsSection: true,
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'dob',
                placeholder: null,
                as: 'input',
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
            },
        ],
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
    },
    {

        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__select_gender__",
        fields: [
            {
                // label: 'Are you a homeowner?',
                name: 'title',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_title_female__", "value":"ms" },
                    { "text":"__opt_title_male__", "value":"mr" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        // beforeNextStep: 'executeSubmitApplication',
        title: "__what_is_your_name__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
        ],
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        // textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeSubmitApplication',
        title: "__how_to_contact__",
        fields: [
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                textBottom: '__phone_number_sms_results__'
            },
            {
                // label: 'Credit Auth',
                label: false,
                name: 'opt_in',
                placeholder: '',
                as: 'input',
                type: 'checkbox',
                value: null,
                // validationRules: 'required',
                // fieldOuterClass: 'col-md-10 offset-md-1',
                fieldInnerClass: 'large-checkbox',
                // choices: [
                //     { "text":'__opt_opt_in_consent__', "value":true },
                // ]
                choices: (app) => {
                    if(app.projectBrandKey) {
                        if(app.projectBrandKey == 'lc') {
                            return [
                                { "text":'__opt_opt_in_consent__', "value":true },
                            ];
                        }
                        else if(app.projectBrandKey == 'comparehub') {
                            return [
                                { "text":'__opt_opt_in_consent_by_lc__', "value":true },
                            ];
                        }
                    }

                    return [
                        { "text":'__opt_opt_in_consent_by_comparehub__', "value":true },
                    ];
                },
            },
        ],
        nextButtonText: '__submit__',
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
];

export default steps;
